import styled from 'styled-components';

import {getColor, getRem, ms} from '@yourcoach/shared/styles';
import {Button} from '@yourcoach/shared/uikit/Button';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

import ModalNew from '@src/components/ModalNew';

const SModal = styled(ModalNew)`
  .body.body {
    width: 65vw;
    max-width: ${ms(500)};
    padding: ${ms(20)};
  }
`;

export {SModal as Modal};

export const Footer = styled(View)`
  flex-direction: column;
`;

export const FooterButton = styled(Button).attrs({
  scheme: 'error',
  variant: 'outlined',
})`
  height: ${ms(50)};
  border-radius: ${ms(12)};
  align-items: center;
  justify-content: center;
  margin-top: ${ms(20)};
`;

export const FooterButtonText = styled(Text).attrs({weight: 'semibold'})`
  color: ${getColor('error')};
  font-size: ${getRem(15)};
  letter-spacing: ${getRem(-0.24)};
`;
